import { render, staticRenderFns } from "./ruleDialog.vue?vue&type=template&id=15a6775c"
import script from "./ruleDialog.vue?vue&type=script&lang=js"
export * from "./ruleDialog.vue?vue&type=script&lang=js"
import style0 from "./ruleDialog.vue?vue&type=style&index=0&id=15a6775c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports